import { Box, VStack } from "@kazaar-platform/design-system";
import Skeleton from "react-loading-skeleton";

export const StatusActionsTabSkeleton = () => {
  return (
    <VStack gap="sp-md" w="100%" h="100vh">
      {Array(3).map((i) => (
        <VStack key={i} gap="sp-md" w="100%" h="400px">
          <Skeleton height={20} width={250} />

          <Box rounded="br-lg" bgColor="elevation.first" p="sp-lg">
            <Skeleton height={10} width={300} count={i % 2 === 0 ? 7 : 3} />
          </Box>
        </VStack>
      ))}
    </VStack>
  );
};
